"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinalPattern = void 0;
const Pattern_1 = require("./Pattern");
class FinalPattern extends Pattern_1.Pattern {
    constructor(pattern) {
        super(pattern.board, pattern.cells);
        this.collisions = pattern.getCollisions();
    }
    getCollisions() {
        return this.collisions;
    }
}
exports.FinalPattern = FinalPattern;
